import * as Api from '../utils/API';
import {
    PGTOWEB_ISLOADING, PGTOWEB_LIST
} from '../actions/ActionsTypes';

export const pgtoWebListAction = (entidade) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: PGTOWEB_ISLOADING, payload: true });
        Api.getPgtoWebList(entidade).then(dados => {
            dispatch({ type: PGTOWEB_LIST, payload: dados })
            dispatch({ type: PGTOWEB_ISLOADING, payload: false })
            resolve([])
        }).catch(error => {
            reject(error);
        })
    });
